/**
 * Verifică dacă un număr de telefon conține cel puțin o cifră
 * @param {string} phone
 * @returns {boolean}
 */
export const isValidPhone = (phone) => /^\d+$/.test(phone);

/**
 * Verifică dacă un CNP are exact 13 cifre
 * @param {string} cnp
 * @returns {boolean}
 */
export const isValidCNP = (cnp) => /^\d{13}$/.test(cnp);
